<template>
  <div
    ref="bannerRef"
    class="listing-banner-universal"
  >
    <div class="images">
      <ui-image
        class="images__main"
        :src="props.banner?.image_main"
        :alt="t('bannerInjection.mainPhoto')"
        loading="lazy"
        fit="cover"
        decoding="async"
      />
      <ui-image
        class="images__sub"
        :src="props.banner?.image_sub"
        :alt="t('bannerInjection.subPhoto')"
        loading="lazy"
        fit="cover"
        decoding="async"
      />
    </div>
    <div class="info">
      <div
        class="info__title"
        v-html="props.banner?.title"
      />
      <div
        class="info__description"
        v-html="props.banner?.description"
      />
      <ui-button
        class="info__button"
        :color-mode="UiButtonColorMode.NEUTRAL"
        :text="props.banner?.button?.text"
        @clicked="onClickBtn"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { UiImage } from '@experience/core-image-ui';
  import { UiButton, UiButtonColorMode } from '@experience/core-button-ui';

  import type { GetListingBannersItemBannerParamsResponse } from '@/shared/api/experience';
  import { useI18n } from '@experience/i18n';
  import ru from '../i18n/ru.json';
  import { useBannerNavigation } from '../composables/useBannerNavigation';

  interface Props {
    banner: GetListingBannersItemBannerParamsResponse;
  }

  const props = defineProps<Props>();
  const emit = defineEmits<{ onClick: [] }>();

  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  const { handleBannerClick } = useBannerNavigation();

  const onClickBtn = () => {
    emit('onClick');
    handleBannerClick(props.banner?.button);
  };
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography' as typography;

  .listing-banner-universal {
    display: flex;
    flex-direction: column;
  }

  .info {
    padding: 24px;
  }

  .info__title {
    margin-bottom: 8px;

    @include typography.base-700-500-extra;
  }

  .info__description {
    margin-bottom: 16px;

    @include typography.base-400-400-regular;
  }

  .images {
    --sub-photo-width: 114px;
    --gap-between-imgs: 4px;
    display: flex;
    flex-grow: 1;
    gap: var(--gap-between-imgs);
    min-height: 0;
  }

  .images__main {
    object-fit: cover;
    width: calc(100% - var(--sub-photo-width) - var(--gap-between-imgs));
  }

  .images__sub {
    object-fit: cover;
    width: var(--sub-photo-width);
    height: 130px !important;
  }
</style>
